import {postRequest,postRequestSearch} from "./helper"

export const unreadChatAction        = (data) => postRequest('change_status',data);
export const readChatApi             = (data) => postRequest('change_message_status',data);
export const chatUserListApi         = (data) =>  postRequest('user_list_company ',data);
export const chatUserListApiSearch   = (data) =>  postRequestSearch('user_list_company ',data);
export const getCompanyUserListApi   = (data) => postRequest('company_list_user',data);
export const forwardChatApi          = (data) => postRequest('',data);
export const getChatListApi          = (data) => postRequest('chat_list',data);
export const chatBlockApi            = (data) => postRequest('user-block',data);
export const chatUnBlockApi          = (data) => postRequest('user-unblock',data);





// WEBPACK FOOTER //
// ./src/api/Chat.js